import React from 'react';
import { Link } from 'react-router-dom';

function ProductCard({ title, description, links, isComingSoon }) {
  return (
    <div className="product-card">
      <h3>{title}</h3>
      <p>{description}</p>
      {isComingSoon ? (
        <p className="coming-soon">Coming Soon!</p>
      ) : (
        links && links.length > 0 && (
          <div className="card-links">
            {links.map((link, index) => (
              <div key={index} className="card-link-item">
                <Link to={link.url}>
                  {link.text}
                </Link>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
}

export default ProductCard; 